import * as types from "./mutation-types";

export default {
  setCollectData(state, data) {
    state.collectData = data;
  },
};
